<template>
  <svg width="33px" height="32px" viewBox="0 0 33 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>45CE6F02-C640-4B3F-B74C-40637A9B444C</title>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Tasks---Sub-Task" transform="translate(-375.000000, -540.000000)" fill="#000000" fill-rule="nonzero">
        <g id="Content" transform="translate(370.000000, 430.000000)">
          <g id="List" transform="translate(0.000000, 42.000000)">
            <g id="Molecules/Task/Log" transform="translate(6.000000, 60.000000)">
              <g id="Icon" transform="translate(0.000000, 8.000000)">
                <path d="M22.36,15.68 L22.36,14 L9,14 L9,15.68 L22.36,15.68 Z M22.36,19 L22.36,17.32 L9,17.32 L9,19 L22.36,19 Z" id=""></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DragIcon',
};
</script>

<style scoped>

</style>
